import {TemplateEditor} from 'TemplateEditor'
import EventPage from 'organization/Event/EventPage'
import React from 'react'
import styled from 'styled-components'

/** Bounded height so the template editor flex + sidebar scroll layout works. */
const DesignPageBody = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 76px);
  max-height: calc(100vh - 76px);
  min-height: 0;
`

export const EventDesign = () => {
  return (
    <EventPage>
      <DesignPageBody>
        <TemplateEditor />
      </DesignPageBody>
    </EventPage>
  )
}
